var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLayer2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 51,
    viewBox: "0 0 47 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.66675 1H39.3334V21C39.3334 22.9698 38.9454 24.9204 38.1916 26.7403C37.4378 28.5601 36.3329 30.2137 34.94 31.6066C33.5471 32.9995 31.8935 34.1044 30.0737 34.8582C28.2538 35.612 26.3032 36 24.3334 36H22.6667C18.6885 36 14.8732 34.4196 12.0601 31.6066C9.2471 28.7936 7.66675 24.9782 7.66675 21V1Z",
    stroke: "#0055C3",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 27.6666V17.6666",
    stroke: "#0055C3",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1 17.6667C1 15.8986 1.70238 14.2029 2.95262 12.9526C4.20286 11.7024 5.89856 11 7.66667 11",
    stroke: "#0055C3",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M46 27.6666V17.6666",
    stroke: "#0055C3",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M45.9999 17.6667C45.9999 15.8986 45.2975 14.2029 44.0473 12.9526C42.7971 11.7024 41.1014 11 39.3333 11",
    stroke: "#0055C3",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5 36V49.3333",
    stroke: "#0055C3",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3333 49.3334H32.6666",
    stroke: "#0055C3",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3166 9.91661L25.8333 14.2333C25.8863 14.3986 25.9877 14.5441 26.1244 14.6511C26.2611 14.7581 26.4268 14.8215 26.5999 14.8333L30.9999 15.0166C31.1984 15.0101 31.3935 15.0695 31.5547 15.1854C31.7159 15.3013 31.8343 15.4673 31.8913 15.6575C31.9484 15.8477 31.941 16.0515 31.8702 16.237C31.7994 16.4225 31.6692 16.5794 31.4999 16.6833L28.0499 19.5333C27.9184 19.6495 27.821 19.7993 27.7681 19.9667C27.7153 20.134 27.709 20.3126 27.7499 20.4833L28.9499 24.9166C29.0012 25.0888 28.9988 25.2724 28.943 25.4432C28.8872 25.6139 28.7806 25.7636 28.6376 25.8722C28.4946 25.9808 28.3218 26.0433 28.1424 26.0512C27.9629 26.0592 27.7853 26.0122 27.6333 25.9166L23.9833 23.3499C23.8412 23.2517 23.6726 23.1992 23.4999 23.1992C23.3272 23.1992 23.1587 23.2517 23.0166 23.3499L19.3666 25.9166C19.2145 26.0122 19.0369 26.0592 18.8575 26.0512C18.678 26.0433 18.5053 25.9808 18.3623 25.8722C18.2192 25.7636 18.1127 25.6139 18.0569 25.4432C18.0011 25.2724 17.9987 25.0888 18.0499 24.9166L19.2499 20.4833C19.2909 20.3126 19.2846 20.134 19.2317 19.9667C19.1789 19.7993 19.0815 19.6495 18.9499 19.5333L15.4999 16.6166C15.3307 16.5128 15.2005 16.3559 15.1297 16.1703C15.0589 15.9848 15.0515 15.7811 15.1085 15.5909C15.1656 15.4006 15.2839 15.2347 15.4452 15.1187C15.6064 15.0028 15.8015 14.9435 15.9999 14.9499L20.3999 14.7666C20.5731 14.7549 20.7388 14.6914 20.8755 14.5844C21.0122 14.4775 21.1136 14.3319 21.1666 14.1666L22.6833 9.84995C22.7498 9.68338 22.8663 9.54154 23.0168 9.44399C23.1673 9.34643 23.3443 9.29797 23.5235 9.30529C23.7027 9.3126 23.8752 9.37533 24.0173 9.48482C24.1593 9.59432 24.2639 9.74518 24.3166 9.91661Z",
    stroke: "#0055C3",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLayer2);
export default __webpack_public_path__ + "static/media/Layer 2.e9f00da6543505caa4449b784cb67465.svg";
export { ForwardRef as ReactComponent };